<template>
  <box-generic
    v-if="title && content?.length"
    :header="title"
    class="teacher-box"
    :header-class="computedHeaderClass"
    h-stretch
  >
    <template v-for="(contentItem, index) in content" :key="index">
      <div
        v-if="contentItem._rendered"
        class="font-bree"
        v-html="contentItem._rendered"
      />
    </template>
  </box-generic>
</template>

<script>
import BoxGeneric from "../BoxGeneric.vue";
import { mapGetters } from "vuex";

export default {
  name: "MaterialBox",
  components: {
    BoxGeneric,
  },
  computed: {
    ...mapGetters(["activeSeasonContentForSchoolLevel"]),
    computedHeaderClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      return slug ? `title-block title-block-${slug}` : "title-block";
    },
  },
  props: {
    title: {
      type: String,
    },
    content: {
      type: Array,
    },
  },
};
</script>
<style>
.teacher-box a {
  text-decoration: none;
  transition: text-decoration 0.2s ease;
}

.teacher-box a:hover {
  text-decoration: underline;
}

.teacher-box .Button,
.teacher-box .Button--primary {
  border-radius: 9999px;
  text-decoration: none;
  box-shadow: none;
  transform: none;
}

.teacher-box .Button:hover,
.teacher-box .Button--primary:hover {
  text-decoration: none;
  box-shadow: none;
  transform: none;
}
</style>
